export default __webpack_public_path__ + "static/media/one.da102b5e.ogg";